module.exports = __webpack_public_path__ + "static/media/SummaryCh11_A01378565.bcd4af94.pdf";